// extracted by LIB_CSS_EXTRACT_LOADER
import "./tabs_module.css"
export default {"list":"list-J1rQVj","tab":"tab-Ngb9CQ","indicator":"indicator-kKQ3hg","panel":"panel-rP4hUn"};